const getters = {
    info: state=> state.info,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js